<div class=" container-fluid py-3 left-menu-space" id="divMainContainer" role="main">
  <div class="page-title-box d-flex justify-content-between bd-highlight">
    <h4 class="mb-0 f-bold-dubai text-secondary pb-1">Meeting Location</h4>
    <div class="page-title-right pb-1">
      <div class="form-group float-left position-relative">
        <input type="text" class="form-control pr-4" id="formGroupExampleInput2" placeholder="Search" [(ngModel)]="searchText"  (keyup)="searchGrid()" [ngModelOptions]="{standalone: true}" >
        <button class="position-absolute position-top-8 border-0 bg-white position-right-5 d-block p-0"><i class="la la-search fa-lg text-secondary rotate-icon"></i></button>
      </div>
      <div class="float-left">
        <a class="btn" (click)="exportExcel()"><i class="fa fa-file-excel-o fa-lg"></i></a>
        <a class="btn btn-success btn-sm text-white rounded-circle text-center px-0 wh-30" (click)="openModal(meetingLocationAdd,'add')"><i class="la la-plus fa-lg "></i></a>
      </div>
    </div>
  </div>

  <div class="card rounded pt-2 h-100">
    <div class="pt-2 px-3 pb-3 border-bottom-0">
      <h6 class="card-title d-inline f-bold-dubai">Meeting Location</h6>
    </div>
    <div class="p-3" id="loaderBg">
      <div class="loader-bg" *ngIf="isLoader"></div>
      <div *ngIf="data==null ||data.length<=0 && !isLoader" class="border px-3 py-4 text-center rounded text-secondary">
        <!--<img src="{{noDataImage}}" alt="No Data" />-->
        <h5 class="pb-4 pt-2">No Data Available</h5>
      </div>
      <table class="table border-0 table-border-td table table-striped" *ngIf="data!=null && data.length>0">
        <thead>
          <tr>
            <th>ID</th>
            <th class="w-40">Location Code</th>
            <th class="w-40">Location Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>

          <tr *ngFor="let item of data">
            <td>{{item.locationUno}}</td>
            <td>{{item.locationCode}}</td>
            <td>{{item.locationName}}</td>
            <td><a (click)="openModal(meetingLocationAdd,'edit');editMeetingLocation(item);" class="text-secondary px-1" title="Edit"><i class="la la-pencil fa-lg"></i></a> <a (click)="DeleteConfirm(item)" class="text-danger fa-lg px-1" title="Delete"><i class="la la-trash-o"></i></a></td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #meetingLocationAdd>
  <div class="modal-header pb-0">
    <div class="custom-tab d-block w-100">

      <h4 class="modal-title text-left px-2">Add New Record</h4> <small class="px-2"><a (click)="modalRef.hide()" class="text-secondary"></a></small>
      <button type="button" class="close close-abs text-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true"><i class="la la-close"></i></span>
      </button>

    </div>
  </div>
  <form name="meetingLocationForm" (ngSubmit)="meetingLocationForm.form.valid && AddEditMeetingLocation()" #meetingLocationForm="ngForm" novalidate>
    <div class="modal-body px-3">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="locationCode">Location Code<span class="text-danger">*</span></label>
            <input type="text" class="form-control" [ngClass]="{ 'is-invalid': meetingLocationForm.submitted && locationCode.invalid }" name="locationCode"
                   [(ngModel)]="model.locationCode" #locationCode="ngModel" required placeholder="Enter the location code" />
            <div *ngIf="meetingLocationForm.submitted && locationCode.invalid" class="invalid-feedback">
              <div *ngIf="locationCode.errors.required" class="text-danger">Enter the location code</div>
            </div>
          </div>
        </div>
         <div class="col-md-6 col-sm-6">
           <div class="form-group">
             <label for="locationName">Location Name<span class="text-danger">*</span></label>
             <input type="text" class="form-control" id="meetingName" [ngClass]="{ 'is-invalid': meetingLocationForm.submitted && locationName.invalid } " name="locationName"
                    [(ngModel)]="model.locationName" #locationName="ngModel" required placeholder="Enter the location name">
             <div *ngIf="meetingLocationForm.submitted && locationName.invalid" class="invalid-feedback">
               <div *ngIf="locationName.errors.required" class="text-danger">Enter the location name</div>
             </div>
           </div>
            </div>
        

      </div>
      <div class="modal-body-footer clearfix">
        <div class="form-group float-right">
          <button type="button" class="btn btn-secondary px-4" (click)="modalRef.hide()">Cancel</button>
          <button class="btn btn-success px-4 mx-2">Submit</button>
        </div>
      </div>
    </div>
  </form>

 

</ng-template>
